// extracted by mini-css-extract-plugin
export default {"alternativePaginationButton":"AlternativePaginationButton__alternativePaginationButton____EVPf"};